import classNames from "classnames";
import React from "react";
import { FmButton, FmUnderlineNav } from "..";
import { FmBox } from "../FmBox";
import { useIsMobile } from "../../Hooks";

import useStyles from "./FmCustomizeBox.style";
import { useTranslation } from "react-i18next";

interface FmWarningBoxProps {
    productName: string;
    percentages: string;
    onLinkClick: () => void;
    onButtonClick: () => void;
}

const FmCustomizeBox = ({ productName, percentages, onLinkClick, onButtonClick }: FmWarningBoxProps) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const isMobile = useIsMobile();

    return (
        <div className={classes.container}>
            <div className={classes.firstCol}>
                <div className={classes.leftSide}>
                    <span>{t("pageStep3.customize.bestSuit")}: </span>
                    {productName}
                    <span className={classes.percentageSpan}> {percentages}</span>
                </div>
                {!isMobile && (
                    <div className={classes.rightSide}>
                        <FmUnderlineNav title={t("pageStep3.customize.topLink")} onClick={onLinkClick} />
                    </div>
                )}
            </div>
            <div className={classes.secondCol}>
                <div>{t("pageStep3.customize.subDescription")}</div>
            </div>
            <div className={classes.thirdCol}>
                <span>{t("pageStep3.customize.title")} </span>
            </div>
            <div className={classes.forthCol}>
                <span>{t("pageStep3.customize.secondSubDescription")} </span>
            </div>
            {isMobile && (
                <div className={classes.graphlinkMobile}>
                    <FmUnderlineNav title={t("pageStep3.customize.topLink")} onClick={onLinkClick} />
                </div>
            )}
            <FmButton onClick={onButtonClick}>{t("pageStep3.customize.button")}</FmButton>
        </div>
    );
};

export default FmCustomizeBox;
